export const ATTRIBUTE_UPLOAD_BASE_EVENT = `attribute:upload`;

export enum AttributeUploadEvent {
	INIT = `${ATTRIBUTE_UPLOAD_BASE_EVENT}:init`,
	INITIALIZED = `${ATTRIBUTE_UPLOAD_BASE_EVENT}:initialized`,
	EXTEND = `${ATTRIBUTE_UPLOAD_BASE_EVENT}:extend`,

	UPLOAD = `${ATTRIBUTE_UPLOAD_BASE_EVENT}:execute`,
}
